// AI Generated Test
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataPrivacyViolationRepoService } from '@client/app/modules/data-privacy/services/api/data-privacy-violation-repo/data-privacy-violation-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { PAGE_DETAILS_SECTION_CONSTANT } from '@client/app/components/pagedetails/details/sections/page-details-section.constant';

@Component({
    selector: 'page-details-dashboard-charts-data-privacy',
    standalone: false,
    template: `
        <div class="row align-items-center page-details-dashboard-data-privacy-box-chart">
            <div class="offset-4 col-18 page-dashboard-doughnut-container">
                <mon-chart-doughnut *ngIf="!loading"
                                    [labels]="doughnutLabels"
                                    [data]="doughnutData"
                                    [options]="doughnutOptions"
                                    [colors]="colors">
                </mon-chart-doughnut>
            </div>
            <div class="col-26 pl-0">
                <notification-change [title]="'Data issues' | translate"
                                     [digit]="page.data_protection_violations_count"
                                     (click)="onClickHandler.emit({params: {target: pageDetailsSectionPrivacy}})">
                </notification-change>
                <ul class="list-inline pl-4 my-1">
                    <li ngbTooltip="{{ 'High severity issues' | translate }}"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionPrivacy}})">
                        <span class="fas fa-circle high"></span>
                        <span class="sr-only"
                              translate>High severity issues</span>
                        <span class="ml-1">{{ issues.high }}</span>
                    </li>
                    <li ngbTooltip="{{ 'Medium severity issues' | translate }}"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionPrivacy}})">
                        <span class="fas fa-circle medium"></span>
                        <span class="sr-only"
                              translate>Medium severity issues</span>
                        <span class="ml-1">{{ issues.medium }}</span>
                    </li>
                    <li ngbTooltip="{{ 'Low severity issues' | translate }}"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionPrivacy}})">
                        <span class="fas fa-circle low"></span>
                        <span class="sr-only"
                              translate>Low severity issues</span>
                        <span class="ml-1">{{ issues.low }}</span>
                    </li>
                </ul>
            </div>
        </div>
    `,
})
export class PageDetailsDashboardChartsDataPrivacyComponent implements OnInit {
    @Input() page: any;
    @Output() onClickHandler = new EventEmitter<any>();

    issues: any = {
        high: 0,
        medium: 0,
        low: 0,
    };
    pageDetailsSectionPrivacy: any;
    doughnutLabels: any;
    colors: any;
    totalDataIssues: any;
    percentage: any;
    doughnutData: any;
    doughnutOptions: any;
    loading: boolean = false;

    constructor (
        private dataPrivacyViolationRepoService: DataPrivacyViolationRepoService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        this.issues = {
            high: 0,
            medium: 0,
            low: 0,
        };
        this.pageDetailsSectionPrivacy = PAGE_DETAILS_SECTION_CONSTANT.PRIVACY;
        this.setupDoughnutChart();
        this.getDataIssues();
    }

    private setupDoughnutChart (): void {
        const params = {
            page: 1,
            page_size: 0,
        };
        this.doughnutLabels = ['', ''];
        this.colors = ['#4dc0bd', '#dcdcdc'];
        this.dataPrivacyViolationRepoService.getAll(this.page.id, params).then((data: any) => {
            this.totalDataIssues = data.total;
            this.percentage = (this.page.data_protection_violations_count / this.totalDataIssues) * 100;
            this.doughnutData = [
                this.totalDataIssues - this.page.data_protection_violations_count,
                this.page.data_protection_violations_count,
            ];
            this.doughnutOptions = {
                centerText: {
                    percentageLabel: this.pipeService.get('monNumber')((100 - this.percentage) / 100, '0.[00] %'),
                },
                cutoutPercentage: 80,
                tooltips: {
                    enabled: this.totalDataIssues > 0,
                    callbacks: {
                        beforeLabel: function () {
                            return '';
                        },
                        label: (tooltipItem: any, d: any) => {
                            return this.pipeService.get('monNumber')(
                                d.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                                '0,0',
                            );
                        },
                    },
                },
            };
        }, () => {});
    }

    private getDataIssues (): void {
        const params = {
            page: 1,
            page_size: 0,
            status: 'active',
        };
        this.issues = {
            high: 0,
            medium: 0,
            low: 0,
        };
        this.loading = true;
        this.dataPrivacyViolationRepoService.getAll(this.page.id, params).then((data: any) => {
            data.forEach((entry: any) => {
                if (entry.info_type && entry.info_type.priority) {
                    this.issues[entry.info_type.priority] += 1;
                }
            });
        }, () => {})
            .finally(() => {
                this.loading = false;
            });
    }
}
